


















import Vue from "vue";
import Component from "vue-class-component";
import { Emit, Prop } from "vue-property-decorator";
import NumberInput from "@/components/common/NumberInput.vue";

@Component({
  components: {
    NumberInput
  }
})
export default class ServicePublicMoney extends Vue {
  @Prop({ default: 0 }) publicmoney1!: number;
  @Prop({ default: 0 }) publicmoney2!: number;
  @Prop({ default: 1 }) lines!: number;

  get Publicmoney1() {
    return this.publicmoney1;
  }
  set Publicmoney1(newValue) {
    this.updatePublicmoney1(newValue);
    this.changepublicmoney1();
  }

  get Publicmoney2() {
    return this.publicmoney2;
  }
  set Publicmoney2(newValue) {
    this.updatePublicmoney2(newValue);
    this.changepublicmoney2();
  }

  @Emit("update:publicmoney1")
  private updatePublicmoney1(newValue: unknown) {
    return newValue;
  }

  @Emit("update:publicmoney2")
  private updatePublicmoney2(newValue: unknown) {
    return newValue;
  }

  @Emit("changepublicmoney1")
  public changepublicmoney1() {
    return;
  }

  @Emit("changepublicmoney2")
  public changepublicmoney2() {
    return;
  }
}
